import './skill.css'
import { Row,Col } from 'react-bootstrap'

const Skills = () => {
  return (
    <div className='p-3 skill'>
       <Row className='p-4'>
            <Col>
                <h1 className="main-color fw-bolder under text-center">Skills</h1>
            </Col>
       </Row>
        <Row className='p-5 align-items-center justify-content-center'>
         
          <Col sm={6} lg={6}>
            <p className='main-color lead'>
              Since inception of my journey as a front end developer for over 2 years, i've completed jobs for companies as a freelancer,
              collaborated with talented people to create incredible projects during interships and developed substantial personal project.
              <br/>
              <br/>
              i'm stout-headed, naturally curious, and consistently working on improving my skillset to address real world problems.
              These days i am keen on delivering accessible website that looks great on any screen and sustainable projects that are
              well documented and easy to maintain.
              <br/>
              <br/>
              I build web application and sites using technologies such as:     
            </p>              
          </Col>
          <Col sm={6} lg={4} className='d-none d-lg-block'>
            <img className='border border-danger text-center rounded-circle' src="./img.jpg" alt=""/>
          </Col>
        </Row>
       <Row className='align-items-center justify-content-center'>
         <Col sm={6} lg={4}>
            <ul>
                <li><p className='text-white lead'>HTML</p></li>
                <li><p className='text-white lead'>Css</p></li>
                <li><p className='text-white lead'>JavaScript</p></li>
                <li><p className='text-white lead'>Bootstrap -5</p></li>
            </ul>
         </Col>
         <Col sm={6} lg={4}>
            <ul>
                <li><p className='text-white lead'>React JS</p></li>
                <li><p className='text-white lead'>Styled-Components</p></li>
                <li><p className='text-white lead'>Netlify</p></li>
                <li><p className='text-white lead'>GitHub etc...</p></li>
            </ul>
         </Col>
       </Row>
    </div>
  )
}

export default Skills